import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class DBTimetField extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value ? this.props.value.trim() : '' };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.value !== prevProps.value ||
            this.props.field !== prevProps.field) {
            this.setState((state) => {
                return { value: this.props.value ? this.props.value : '', hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            value: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 15000)
        });

        if (!this.props.disabled && this.props.handleValueChange) {
            this.props.handleValueChange(event.target.value);
        }
    }

    saveValue() {
        if (this.state.hasChanges) {
            this.state.value.trim() === '' ?
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field)
                :
                this.props.updateTimeField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.state.value);
            this.setState({ hasChanges: false });

            if (this.props.onChange) {
                this.props.onChange(this.state.value);
            }
        }
    }

    handleOnBlur() {
        this.saveValue();
        clearTimeout(this.state.changingTimeout);
    }

    render() {
        return (
            <input
                className={this.props.className ? this.props.className : ''}
                type="time"
                title={this.props.placeholder !== undefined && this.props.placeholder !== null ? this.props.placeholder : ''}
                placeholder={this.props.placeholder}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                value={this.state.value}
                disabled={this.props.disabled}
            />
        );
    }
}

function mapDispatchToProps(dispatch) {

    return {
        updateTimeField: bindActionCreators(noteActions.updateTimeField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field],
    };
}

const connectedDBTimetField = connect(mapStateToProps, mapDispatchToProps)(DBTimetField);
export { connectedDBTimetField as DBTimetField };